import React from "react";
import { Button, DatePicker, Spin, Table, Typography } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment, { Moment } from "moment";
import useProgramAttendanceReport from "../../hooks/attendance/useProgramAttendanceReport";

const { Text } = Typography;

interface Props {
  programId: number;
}

export default function AttendanceMonthlyReport({ programId }: Props) {
  const [selectedMonth, setSelectedMonth] = React.useState<Moment>(
    moment().startOf("month")
  );

  const { loading, exporting, rows, exportToExcel } = useProgramAttendanceReport(
    programId,
    selectedMonth
  );

  const columns = [
    {
      title: "Estudiante",
      dataIndex: "userName",
      width: 220,
    },
    {
      title: "Código",
      dataIndex: "studentCode",
      width: 110,
      render: (val: string) => val ?? "—",
    },
    {
      title: "Total clases",
      dataIndex: "totalClasses",
      width: 120,
      align: "center" as const,
    },
    {
      title: "Asistencias",
      dataIndex: "present",
      width: 110,
      align: "center" as const,
    },
    {
      title: "Inasistencias",
      dataIndex: "absent",
      width: 120,
      align: "center" as const,
    },
    {
      title: "% Asistencia",
      dataIndex: "attendancePercent",
      width: 120,
      align: "center" as const,
      render: (val: number) => `${val}%`,
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 items-center justify-between">
        <DatePicker
          picker="month"
          value={selectedMonth}
          format="MMMM YYYY"
          allowClear={false}
          onChange={(date) => date && setSelectedMonth(date.startOf("month"))}
        />
        <Button
          icon={<DownloadOutlined />}
          disabled={!rows.length}
          loading={exporting}
          onClick={exportToExcel}
        >
          Exportar Excel
        </Button>
      </div>

      <Spin spinning={loading}>
        {rows.length === 0 && !loading ? (
          <Text type="secondary">
            No hay estudiantes inscritos en este programa.
          </Text>
        ) : (
          <Table
            rowKey="programStudentId"
            columns={columns}
            dataSource={rows}
            pagination={{
              pageSize: 20,
              showSizeChanger: true,
              pageSizeOptions: ["15", "20", "50", "100"],
              showTotal: (total) => `${total} estudiantes`,
            }}
            scroll={{ x: 700 }}
          />
        )}
      </Spin>
    </div>
  );
}
